<<template>
  <article>
    <section class="xbed-sub-title">
      <span>关联管理</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>渠道列表</BreadcrumbItem>
        <BreadcrumbItem>关联管理：{{title}}</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
      <TabPane label="渠道门店" name="hotelList" ref="hotelList">
        <Form @submit.native.prevent="preventSubmit" :model="otaHotelForm" inline>
          <FormItem  label="省市：" prop="city" :label-width="80">
            <Cascader :data="provCityList" v-model="otaHotelForm.city" :load-data="queryHotelCities" transfer></Cascader>
          </FormItem>
          <FormItem prop="hotelId" label="门店ID：" :label-width="80">
            <Input type="text" v-model="otaHotelForm.hotelId" placeholder="搜索门店ID"></Input>
          </FormItem>
          <FormItem prop="hotelName" label="门店名称：" :label-width="85">
            <Input type="text" v-model="otaHotelForm.hotelName" placeholder="搜索门店名"></Input>
          </FormItem>
          <FormItem prop="hotelQuery">
            <Button type="primary" @click="queryWithKeyword">查询</Button>
          </FormItem>
          <FormItem prop="addHotel">
            <Button @click="openModal" type="primary">新增门店匹配</Button>
          </FormItem>
        </Form>
        <Table stripe class="tableList" :loading="hotelList.loading" height="450" :columns="columns.hotel" :data="hotelList.data"></Table>
        <div style="float: left;margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :total="hotelList.count" :current="hotelList.page" :page-size="hotelList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </TabPane>
      <TabPane label="渠道房型" name="roomTypeList" ref="roomTypeList">
        <Form @submit.native.prevent="preventSubmit" :model="otaRoomTypeForm" inline>
          <FormItem prop="hotelName" label="所属门店：" :label-width="85">
            <Input type="text" v-model="otaRoomTypeForm.hotelName" placeholder="查询关键字"></Input>
          </FormItem>
          <FormItem prop="roomTypeName" label="房型名称：" :label-width="85">
            <Input type="text" v-model="otaRoomTypeForm.roomTypeName" placeholder="查询关键字"></Input>
          </FormItem>
          <FormItem prop="dockingStatus" label="打包状态：" :label-width="85">
            <Select v-model="otaRoomTypeForm.dockingStatus" filterable>
              <Option value="S00">全部</Option>
              <Option value="1">已打包</Option>
              <Option value="0">未打包</Option>
            </Select>
          </FormItem>
          <FormItem prop="roomTypeQuery">
            <Button type="primary" @click="queryWithKeyword">查询</Button>
          </FormItem>
        </Form>
        <Table stripe :loading="roomTypeList.loading" height="450" :columns="columns.roomType" :data="roomTypeList.data"></Table>
        <div style="float: left;margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :total="roomTypeList.count" :current="roomTypeList.page" :page-size="roomTypeList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </TabPane>
    </Tabs>

    <Modal v-model="modalDisplay" ref="addHotelModal" :loading="modalLoading" :width="1000" title="xbed门店列表" @on-ok="prepareAddHotel" @on-cancel="cancelAddHotel" ok-text="新增" cancel-text="关闭">
      <Form @submit.native.prevent="preventSubmit" :model="modalForm" inline>
        <FormItem  label="省市：" prop="city" :label-width="100">
          <Cascader v-model="modalForm.city" :data="provCityList" :load-data="queryHotelCities"></Cascader>
        </FormItem>
        <FormItem prop="modalQuery">
          <Button type="primary" @click="queryHotelListWithUnbind">查询</Button>
        </FormItem>
        <FormItem v-if="modalBundle.data.length>0" style="float: right;" label="查询：" prop="modalKeyWord" :label-width="100">
          <Input type="text" v-model="modalForm.modalKeyWord"  @on-enter="queryModalDataWithKeyword" @on-change="queryModalDataWithKeyword" placeholder="查询关键字"></Input>
        </FormItem>
      </Form>
      <Table :height="400" stripe highlight-row :loading="modalBundle.loading" :columns="modalColumns" :data="modalDisplayData" @on-current-change="changeSelectedHotel"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page placement="top" :total="modalBundle.count" :current="modalBundle.page" @on-change="changeModalPage"></Page>
      </div>
      <br/>
      <Form v-if="modalSelectedHotel.chainId" ref="modalSelectedHotel" :model="modalSelectedHotel" :rules="ruleValidate" :label-width="150">
        <FormItem label="已选门店ID" prop="title">
          <span>{{modalSelectedHotel.chainId||""}}</span>
        </FormItem>
        <FormItem label="已选门店名称" prop="title">
          <span>{{modalSelectedHotel.chainName||""}}</span>
        </FormItem>
        <FormItem label="门店地址" prop="title">
          <span>{{modalSelectedHotel.address||""}}</span>
        </FormItem>
        <FormItem label="飞猪门店名称" prop="feizhuName">
          <Input style="width:350px" v-model="modalSelectedHotel.feizhuName" prop="feizhuName"></Input>
        </FormItem>
        <!-- <FormItem label="是否已在飞猪上线">
          <RadioGroup v-model="modalSelectedHotel.isDirectLink">
            <Radio :label="0" :value="0">未上线（新上门店）</Radio>
            <Radio :label="1" :value="1">已上线（非直连转为直连）</Radio>
          </RadioGroup>
        </FormItem> -->
      </Form>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryHotelProvinces();
    this.toggleTab(this.currTabName);
  },
  data() {
    return {
      channelId: 4,
      title: "门店列表",
      currBundleName: "hotel",
      currTabName: "hotelList",
      provCityList: [],
      hotelList: {
        tabName: "hotelList",
        title: "门店列表",
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      },
      roomTypeList: {
        tabName: "roomTypeList",
        title: "房型列表",
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      },
      columns: {
        hotel: [
          {
            title: "渠道门店ID",
            key: "xbedHotelId",
            align: "center",
            width: 100,
            fixed: 'left'
          },
          {
            title: "渠道门店名称",
            key: "channelHotelName",
            align: "center",
            width: 300
          },
          {
            title: "省市区",
            key: "provCityDist",
            align: "center",
            width: 300
          },
          {
            title: "街道地址",
            key: "address",
            align: "center",
            width: 350
          },
          {
            title: "xbed门店",
            key: "xbedHotelName",
            align: "center",
            width: 200
          },
          // {
          //   title: "所属热点",
          //   key: "hotspot",
          //   align: "center",
          //   width: 200
          // },
          {
            title: "匹配状态",
            key: "status",
            align: "center",
            width: 130,
            render: (h, params) => {
              let status = (params.row.matchStatus == "S50" ? "匹配中" :
                            params.row.matchStatus == "S51" ? "匹配成功" :
                            params.row.matchStatus == "S52" ? "匹配失败" : "待匹配");
              return h("Tag", {
                props: {
                  color: (params.row.matchStatus == "S50" ? "yellow" :
                            params.row.matchStatus == "S51" ? "green" :
                            params.row.matchStatus == "S52" ? "red" : "blue")
                },
              }, status);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        if(this.$router){
                          this.$router.push({path: "/app/Ota/Ota/feiZhu/ChannelHotelDetail", query: { hotelId: params.row.channelHotelId }});
                        }else{
                          window.open(`#/Ota/Ota/feizhuChannelHotelDetail?hotelId=${params.row.channelHotelId}`);
                        }
                      }
                    }
                  },
                  "查看详情"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.matchChannelHotel(params.index);
                      }
                    }
                  },
                  (params == "S52"?"重新匹配":"更新匹配状态")
                )
              ]);
            }
          }
        ],
        roomType: [
          {
            title: "房型id",
            key: "xbedRoomTypeId",
            align: "center",
            width: 100,
            fixed: 'left'
          },
          {
            title: "销售状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let status = "";
              switch(params.row.status) {
                case "S01":
                status = "上架";
                break;
                case "S02":
                status = "下架";
                break;
              }
              return h("div", {}, status);
            }
          },
          {
            title: "房型名称",
            key: "xbedRoomTypeName",
            align: "center",
            width: 300
          },
          {
            title: "所属门店",
            key: "xbedHotelName",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", {}, `${params.row.xbedHotelId}_${params.row.xbedHotelName}`);
            }
          },
          {
            title: "信息房",
            key: "infoRoomName",
            align: "center",
            width: 250,
            render: (h, params) => {
              let infoRoomId = params.row.infoRoomId ? params.row.infoRoomId : '';
              let infoRoomName = params.row.infoRoomName ? params.row.infoRoomName : '';
              let name = infoRoomId && infoRoomName ? `${infoRoomId}_${infoRoomName}` : '';
              return h("div", {}, name);
            }
          },
          {
            title: "取价房",
            key: "priceRoomName",
            align: "center",
            width: 250,
            render: (h, params) => {
              let priceRoomId = params.row.priceRoomId ? params.row.priceRoomId : '';
              let priceRoomName = params.row.priceRoomName ? params.row.priceRoomName : '';
              let name = priceRoomId && priceRoomName ? `${priceRoomId}_${priceRoomName}` : '';
              return h("div", {}, name);
            }
          },
          {
            title: "打包房量",
            key: "dockingCount",
            align: "center",
            width: 120,
            render: (h, params) => {
              let count = params.row.dockingCount? params.row.dockingCount : 0
              return h("div", {}, count);
            }
          },
          {
            title: "在线状态",
            key: "status",
            align: "center",
            width: 120,
            render: (h, params) => {
              let statusString = params.row.status=='S01'? '上线' : '下线';
              return h("div", {}, statusString);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        if(this.$router){
                          this.$router.push({path: "/app/Ota/Ota/feiZhu/channelRoomTypeDetail", query: { roomTypeId: params.row.xbedRoomTypeId }});
                        }else{
                          window.open(`#/Ota/Ota/feizhuChannelRoomTypeDetail?roomTypeId=${params.row.xbedRoomTypeId}`);
                        }
                      }
                    }
                  },
                  "编辑打包"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          render: modalH => {
                            let modalText = `确定删除该房型？`;
                            return modalH(
                              "div",
                              {
                                style: {
                                  fontSize: "16px"
                                }
                              },
                              modalText
                            );
                          },
                          okText: "确定删除",
                          onOk: () => {
                            this.removeRoomType(params.index);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ]
      },
      modalColumns: [
        {
          title: "飞猪门店id",
          key: "chainId",
          align: "center",
          width: 150,
          fixed: 'left'
        },
        {
          title: "飞猪门店名称",
          key: "chainName",
          align: "center",
          width: 200
        },
        {
          title: "省份",
          key: "province",
          align: "center",
          width: 150
        },
        {
          title: "城市",
          key: "city",
          align: "center",
          width: 150
        },
        // {
        //   title: "热点名称",
        //   key: "hotspotName",
        //   align: "center",
        //   width: 250
        // },
        {
          title: "类型",
          key: "type",
          align: "center",
          width: 200,
          render: (h, params) => {
            let status = params.row.chainType == 0 ? "分散" : "聚集"
            return h("div", {}, status);
          }
        }
      ],
      otaHotelForm: {
        city: [],
        hotelId: "",
        hotelName: ""
      },
      otaRoomTypeForm: {
        hotelName: "",
        roomTypeName: "",
        dockingStatus: "S00"
      },
      modalForm: {
        city: [],
        modalKeyWord: ""
      },
      modalDisplay: false,
      modalLoading: true,
      modalDisplayData: [],
      filterModalDataList: [],
      modalSelectedHotel: {},
      ruleValidate: {
        feizhuName: [
            { required: true, message: '飞猪门店名称不能为空', trigger: 'blur' }
        ]
      },
      bundles: [],
      modalBundle: {
        name: "hotel",
        tabName: "门店列表",
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      }
    };
  },
  methods: {
    initSelectHotel(){
      this.modalSelectedHotel.feizhuName = "";
      this.modalSelectedHotel.isDirectLink = 0
    },
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.title = this[tabName].title;
      this[tabName].page = 1;
      this.queryOtaList();
    },
    changePage(pageIndex) {
      this[this.currTabName].page = pageIndex;
      this.queryOtaList();
    },
    changePageSize(pageSize) {
      this[this.currTabName].page = 1;
      this[this.currTabName].pageSize = pageSize;
      this.queryOtaList();
    },
    changeModalPage(pageIndex) {
      this.modalBundle.page = pageIndex;
      this.queryHotelListWithUnbind();
    },
    openModal() {
      this.modalDisplay = true;
    },
    async queryHotelProvinces() {
      let resp = (await API.omsAPI[this.env].ota.queryHotelProvinces(
        this.channelId,
        this.token
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.forEach(prov => {
        prov.label = prov.province;
        prov.value = prov.province;
        prov.loading = false;
        prov.children = [];
      })
      this.provCityList = resp;
    },
    async queryHotelCities(item, callback) {
      item.loading = true;
      let resp = (await API.omsAPI[this.env].ota.queryHotelCities(
        this.channelId,
        item.value,
        this.token
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.forEach(city => {
        city.label = city.city;
        city.value = city.city;
      })
      item.children = resp;
      item.loading = false;
      callback();
    },
    queryWithKeyword(){
      this[this.currTabName].page = 1;
      this[this.currTabName].pageSize = 10;
      this.queryOtaList();
    },
    async queryOtaList() {
      if (this.currTabName == "hotelList") {
        this.queryHotelList();
      } else if (this.currTabName == "roomTypeList") {
        this.queryAllRoomTypeList();
      }
    },
    async queryHotelList() {
      this.hotelList.loading = true;
      let resp = (await this.sendQueryHotelList(
        this.hotelList,
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.result.forEach(hotel => {
        hotel.provCityDist = `${hotel.province?hotel.province:""}${hotel.city?hotel.city:""}${hotel.district?hotel.district:""}`;
      });
      this.hotelList.data = resp.result;
      this.hotelList.page = resp.page;
      this.hotelList.count = resp.count;
      this.hotelList.loading = false;
    },
    sendQueryHotelList(hotelList, token, env) {
      let city = this.otaHotelForm.city.length > 0 ? this.otaHotelForm.city[this.otaHotelForm.city.length-1] : "";
      let hotelId = this.otaHotelForm.hotelId.length ==0 ? 0 :  Number.parseInt(this.otaHotelForm.hotelId);
      return API.omsAPI[env].ota.queryHotelList(
        this.channelId,
        city,
        hotelList.page,
        hotelList.pageSize,
        hotelId,
        this.otaHotelForm.hotelName,
        token
      );
    },
    async queryAllRoomTypeList() {
      this.roomTypeList.loading = true;
      let resp = (await this.sendQueryAllRoomTypeList(
        this.roomTypeList,
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      this.roomTypeList.data = resp.list;
      this.roomTypeList.page = resp.page;
      this.roomTypeList.count = resp.rowCount;
      this.roomTypeList.loading = false;
    },
    sendQueryAllRoomTypeList(roomTypeList, token, env) {
      let dockingStatus = this.otaRoomTypeForm.dockingStatus=="S00" ? "" : this.otaRoomTypeForm.dockingStatus;
      return API.omsAPI[env].ota.queryAllRoomTypeList(
        this.channelId,
        dockingStatus,
        this.otaRoomTypeForm.hotelName,
        this.otaRoomTypeForm.roomTypeName,
        roomTypeList.page,
        roomTypeList.pageSize,
        token
      );
    },
    // 删除门店
    async delHotel(index) {
      let hotel = this.hotelList.data[index];

      let resp = (await API.omsAPI[this.env].ota.removeHotel(
        hotel.xbedHotelId,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除门店失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除门店成功"
        });

        this.hotelList.data.splice(index, 1);
        this.queryHotelList();
      }
    },
    // 删除房型
    async removeRoomType(index) {
      let roomType = this.roomTypeList.data[index];

      let resp = (await API.omsAPI[this.env].ota.removeRoomType(
        this.channelId,
        this.username,
        roomType.xbedRoomTypeId,
        roomType.xbedHotelId,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除房型失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除房型成功"
        });

        this.roomTypeList.data.splice(index, 1);
        this.queryAllRoomTypeList();
      }
    },
    async queryHotelListWithUnbind() {
      if (this.modalForm.city.length==0) {
        this.$Notice.error({
          title: "查询门店失败",
          desc: "请选择省市"
        });
        return;
      }
      this.modalBundle.loading = true;
      let resp = (await this.queryHotelModalListWithUnbind(this.token, this.env)).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.forEach(hotel => {
        hotel.chainType = hotel.chainType == 0 ? "分散" : "聚集";
      })
      this.modalBundle.data = resp;
      this.modalBundle.count = resp.length;
      this.modalBundle.pageCount = (this.modalBundle.count % this.modalBundle.page) == 0 ? (this.modalBundle.count / this.modalBundle.page) : (this.modalBundle.count / this.modalBundle.page + 1)
      this.filterModalDataList = this.modalBundle.data;
      this.displayUnbindHotelList();
      this.modalBundle.loading = false;
    },
    //重新匹配门店
    async matchChannelHotel(index){
      let hotel = this.hotelList.data[index];
      let resp = (await API.omsAPI[this.env].ota.matchChannelHotel(
        //channelHotelId: number, operatorCode: string, operatorName: string, token: string;
        hotel.channelHotelId,
        this.username,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "重新匹配失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "重新匹配成功"
        });
        this.refreshTable();
      }
    },
    queryHotelModalListWithUnbind(token, env) {
      this.initSelectHotel();
      return API.omsAPI[env].ota.queryHotelListWithUnbind(
        this.channelId,
        this.modalForm.city[1],
        this.modalForm.city[0],
        token
      )
    },
    displayUnbindHotelList() {
      let startIndex = (this.modalBundle.page-1) * this.modalBundle.pageSize;
      let endIndex = this.modalBundle.pageSize * this.modalBundle.page;
      this.modalDisplayData = [];
      if (this.modalBundle.count<=5) {
        this.modalDisplayData = this.filterModalDataList
      } else {
        let filterModalDataList = [];
        for (let i=startIndex; i<endIndex; i++) {
          if (!this.filterModalDataList[i]) break;
          filterModalDataList.push(this.filterModalDataList[i]);
        }
        this.modalDisplayData = filterModalDataList;
      }
    },
    queryModalDataWithKeyword() {
      this.modalBundle.loading = true;
      this.filterModalDataList = this.filterModalDataWithKeyword();
      this.modalBundle.page = 1;
      this.modalBundle.count = this.filterModalDataList.length;
      this.modalBundle.pageCount = (this.modalBundle.count % this.filterModalDataList.length) == 0 ? (this.modalBundle.count / this.filterModalDataList.length) : (this.modalBundle.count / this.filterModalDataList.length + 1)
      this.displayUnbindHotelList();
      this.modalBundle.loading = false;
    },
    filterModalDataWithKeyword() {
      let self = this;
      return this.modalBundle.data.filter(function (hotel){
        let result = false;
        for (let itemKey in hotel) {
          if (self.skipKeyFromData(itemKey)) {
            continue;
          }
          let queryItem = '' + hotel[itemKey];
          if (queryItem.toUpperCase().indexOf((self.modalForm.modalKeyWord).toUpperCase()) !== -1) {
            result = true;
            break;
          }
        }
        return result;
      });
    },
    skipKeyFromData(key) {
      let isSkip = false;
      switch(key) {
        case 'address':
        case 'contactName':
        case 'contactPhone':
        case 'remind':
        case 'hotspotId':
          isSkip = true;
          break;
      }
      return isSkip;
    },
    changeSelectedHotel(currHotel) {
      this.initSelectHotel();
      this.modalSelectedHotel = Object.assign({}, this.modalSelectedHotel,currHotel);
    },
    async prepareAddHotel() {
      let validResult = false;
      this.$refs.modalSelectedHotel.validate((valid) => {
        validResult = valid
      })
      if (!validResult) {
        this.$refs.addHotelModal.buttonLoading = false;
        return;
      }
      if (!this.modalSelectedHotel.chainId) {
        this.$Notice.error({
          title: "添加门店失败",
          desc: "未选择门店"
        });
        this.$refs.addHotelModal.buttonLoading = false;
        return;
      }
      let resp = (await API.omsAPI[this.env].ota.addFeizhuChannelHotel(
        this.channelId,
        this.modalSelectedHotel.feizhuName,
        this.modalSelectedHotel.chainId,//门店id
        this.username,
        this.modalSelectedHotel.isDirectLink,
        this.token
      )).data;
      if (resp.retCode) {
        // 错误警告
        this.$refs.addHotelModal.buttonLoading = false;
        this.$Notice.error({
          title: "添加门店失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "添加门店成功"
        });
        this.modalDisplay = false;
        this.refreshTable();
        this.resetAddModalData();
      }
    },
    cancelAddHotel() {
      this.resetAddModalData();
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
    resetTabPane() {
      this.hotelList = {
        tabName: "hotelList",
        title: "门店列表",
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      };
      this.roomTypeList = {
        tabName: "roomTypeList",
        title: "房型列表",
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      };
    },
    resetAddModalData() {
      this.modalBundle = {
        name: "hotel",
        tabName: "门店列表",
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      }
      this.modalDisplayData = [];
      this.modalSelectedHotel = {
        feizhuName: "",
        isDirectLink: 0
      };
      this.modalForm = {
        city: [],
        modalKeyWord: ""
      };
    },
    refreshTable() {
      this.resetTabPane();
      this.otaHotelForm = {
        city: [],
        hotelId: "",
        hotelName: ""
      };
      this.otaRoomTypeForm = {
        hotelName: "",
        roomTypeName: "",
        dockingStatus: "S00"
      };
      this.queryHotelProvinces();
      this[this.currTabName].page = 1;
      this.queryOtaList();
    }
  }
};
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ota/feizhu/list.vue